import React from "react"
import * as Yup from "yup"
import { Field, Formik } from "formik"
import {
  InputField,
  setNullOnEmptyValues,
  transformErrorForForm,
} from "../Form"
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Button,
} from "@material-ui/core"
import { KeyboardBackspace } from "@material-ui/icons"
import ButtonSave from "../ButtonSave"
import { Transition } from "../../consts"

const INITIAL_VALUES = {
  rag_sociale: "",
  piva: "",
  cod_fatturazione: "",
}

const ProdottoSchema = Yup.object().shape({
  rag_sociale: Yup.string().required("Ragione sociale è obbligatoria"),
  piva: Yup.string().required("Partita iva è obbligatoria"),
  cod_fatturazione: Yup.string().required("Codice fattuazione è obbligatorio"),
})

export default function ModalFormCliente({
  cliente,
  save,
  isOpen,
  toggle,
  categories,
}) {
  return (
    <Dialog open={isOpen} onClose={toggle} TransitionComponent={Transition}>
      <DialogTitle onClose={toggle}>
        {cliente ? "Modifica" : "Inserimento"} cliente
      </DialogTitle>
      <Formik
        validationSchema={ProdottoSchema}
        initialValues={cliente ? cliente : INITIAL_VALUES}
        onSubmit={(values, actions) => {
          save(setNullOnEmptyValues(values)).catch((err) => {
            actions.setErrors(transformErrorForForm(err))
          })
        }}
      >
        {({ handleSubmit, isSubmitting, values, setFieldValue }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent dividers>
                <Grid container spacing={3}>
                  <Grid item md={12} xs={12}>
                    <Field
                      label={"Ragione Sociale"}
                      name="rag_sociale"
                      component={InputField}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <Field
                      label={"Partita iva"}
                      name="piva"
                      component={InputField}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <Field
                      label={"Codice fatturazione"}
                      name="cod_fatturazione"
                      component={InputField}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  startIcon={<KeyboardBackspace />}
                  variant="outlined"
                  onClick={toggle}
                >
                  Chiudi
                </Button>
                <ButtonSave
                  disabled={isSubmitting}
                  type="submit"
                  variant="outlined"
                >
                  {cliente ? "Modifica" : "Aggiungi"}
                </ButtonSave>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
